import React from 'react';
import { Box, Container, Stack } from '@mui/material';

interface FilterLayoutProps {
  LocationInput: React.ReactNode;
}

const Divider = (
  <Box sx={{ width: '1px', backgroundColor: 'default.light', height: 'auto', my: 1.5 }} />
);

export const FilterLayout: React.FC<FilterLayoutProps> = ({ LocationInput, children }) => (
  <Box
    sx={(theme) => ({
      display: 'flex',
      flexDirection: 'row',
      position: 'sticky',
      top: { xs: 56, sm: 0 },
      zIndex: 15,
      width: '100%',
      backgroundColor: theme.palette.background.default,
      paddingInline: theme.spacing(5),
      paddingBlock: theme.spacing(2),
      borderBottom: `1px solid ${theme.palette.care.grey[300]}`,
      borderTop: `1px solid ${theme.palette.care.grey[300]}`,
      px: { xs: 2, sm: 0 },
    })}>
    <Container maxWidth="xl">
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column', sm: 'row' },
          gap: 2,
          overflow: 'scroll',
          msOverflowStyle: 'none',
          scrollbarWidth: 'none',
          '&::-webkit-scrollbar': {
            display: 'none',
          },
        }}>
        <Stack
          divider={{ xs: null, sm: Divider }}
          direction={{ xs: 'column', sm: 'row' }}
          gap={{ xs: 1, sm: 2 }}>
          <Box sx={{ width: { xs: '100%', sm: 230 } }}>{LocationInput}</Box>
        </Stack>
        <Stack
          direction="row"
          gap={1}
          sx={{
            overflow: 'scroll',
            msOverflowStyle: 'none',
            scrollbarWidth: 'none',
            '&::-webkit-scrollbar': {
              display: 'none',
            },
          }}>
          {React.Children.map(children, (filterSelectChild) => (
            <Box sx={{ flexShrink: 0 }}>{filterSelectChild}</Box>
          ))}
        </Stack>
      </Box>
    </Container>
  </Box>
);
